
export default [
    {
        path: 'about',
        component: resolve => require(['@/views/about'], resolve),
        name: 'About',
        keepAlive: true,
        meta: {
            nav: '关于我们'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/about.js